import { render, staticRenderFns } from "./SiteTransitionFields.vue?vue&type=template&id=687d92f4&scoped=true"
import script from "./SiteTransitionFields.vue?vue&type=script&lang=js"
export * from "./SiteTransitionFields.vue?vue&type=script&lang=js"
import style0 from "./SiteTransitionFields.vue?vue&type=style&index=0&id=687d92f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687d92f4",
  null
  
)

export default component.exports